/**
 * Trade offers fold the member's note into the generated history message as
 * "<generated text> Note: <note>" (AddTradeOffer.js, OfferPage.jsx). The
 * offer page pulls it back out for display. The old pattern, /Note:\s*(.+)$/,
 * could not cross a line break, so any note typed on more than one line was
 * shown as nothing at all and the other member never saw it (2026-10-23).
 */
const NOTE_PATTERN = /Note:\s*([\s\S]+)$/i;

export function parseOfferNote(message) {
  if (typeof message !== 'string') return null;
  const m = message.match(NOTE_PATTERN);
  if (!m) return null;
  const note = m[1].trim();
  return note.length ? note : null;
}
